import { render, staticRenderFns } from "./ResourceExterneModal.vue?vue&type=template&id=10eb3a3d"
import script from "./ResourceExterneModal.vue?vue&type=script&lang=js"
export * from "./ResourceExterneModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports